<script>
  import http from '@/service/http'
  import { mapState } from 'vuex'
  import { ListSelect } from 'vue-search-select'

  export default {
    name: 'Form',
    components: {
      ListSelect
    },
    data () {
      return {
        usuarios: [],
        orcamento: {},
        revisoes: [],
        os: {
          id: '',
          massa: false,
          andares: '',
          finais: '',
          estrutura_numeros: 'centena',
          bloco: '',
          cliente_id: '',
          orcamento_id: '',
          revisao_id: null,
          proposta_id: '',
          servico: '',
          apartamento: '',
          medidor: '',
          medidor_marca: '',
          medidor_numero: '',
          medidor_leitura: '',
          descricao: '',
          dificuldades: '',
          solucao: '',
          valor: '',
          inicio: '',
          tempo_execucao: '',
          responsavel_id: ''
        },
        editorDescricao: {
          placeholder: 'Descrição',
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'strike'],
              [{'color': []}, {'background': []}],
              [{'align': []}],
              ['clean']
            ]
          }
        },
        editorDificuldades: {
          placeholder: 'Dificuldades Encontradas',
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'strike'],
              [{'color': []}, {'background': []}],
              [{'align': []}],
              ['clean']
            ]
          }
        },
        editorSolucao: {
          placeholder: 'Solução Proposta',
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'strike'],
              [{'color': []}, {'background': []}],
              [{'align': []}],
              ['clean']
            ]
          }
        }
      }
    },
    mounted () {
      this.fecth()
    },
    watch: {
      '$route' () {
        if (this.$route.params.id != null) {
          this.fecth()
        }
      }
    },
    methods: {
      async fecth () {
        this.clear()
        const {id} = this.$route.params
        if (id !== undefined) {
          const {data} = await http.get(`/os/${id}/orcamento`)
          if (data && data.orcamento && data.orcamento.proposta) {
            this.orcamento = data.orcamento
            this.os.cliente_id = this.orcamento.cliente_id
            this.os.orcamento_id = this.orcamento.id
            this.os.proposta_id = this.orcamento.proposta.id
            this.os.valor = this.orcamento.proposta.valor_total
            // this.os.descricao = data.servicos
            this.os.apartamento = this.orcamento.complemento
            if(this.orcamento.revisao_id){
              this.os.revisao_id = this.orcamento.revisao_id
            }
          } else {
            this.$router.push({name: 'orcamentos.index'})
          }
          this.usuarios = data.usuarios
          this.revisoes = data.revisoes
        }
        setTimeout(function () {
          $('.collapsible').collapsible()
          $('.collapsible').collapsible('close', 0)
          $('.collapsible').collapsible('close', 1)
          $('.collapsible').collapsible('close', 2)
          $('.collapsible').collapsible('open', 0)
          window.Materialize.updateTextFields()
        }, 0)
      },
      validate () {
        this.$validator.validateAll().then(success => {
          if (!success) {
            this.$swal({
              title: 'Ops, encontramos um erro!',
              html: 'Um ou mais campos estão com seu preenchimento incorreto',
              type: 'error',
              cancelButtonText: 'Ok'
            })
            return false
          }
          this.submit()
        })
      },
      async submit () {
        const verb = 'post'
        const url = '/os'
        const {data} = await http[verb](url, this.os)
        if (data != null) {
          this.$emit('update-os-list', {os: data.os})
          if (this.os.massa === true) {
            this.$router.push({name: 'os.index'})
          } else {
            this.$router.push({name: 'os.form', params: {id: data.os[0].id}})
          }
        }
      },
      clear () {
        this.os = {
          id: '',
          massa: false,
          andares: '',
          finais: '',
          estrutura_numeros: 'centena',
          bloco: '',
          cliente_id: '',
          orcamento_id: '',
          proposta_id: '',
          revisao_id: null,
          servico: '',
          apartamento: '',
          medidor: '',
          medidor_marca: '',
          medidor_numero: '',
          medidor_leitura: '',
          descricao: '',
          dificuldades: '',
          solucao: '',
          valor: '',
          inicio: '',
          tempo_execucao: '',
          responsavel_id: ''
        }
      }
    },
    computed: {
      ...mapState(['loading'])
    }
  }
</script>

<template>
  <div>

    <form>

      <div class="row">

        <div class="col s12 m10 offset-m1">

          <ul class="collapsible popout" data-collapsible="accordion">
            <li>
              <div class="collapsible-header green-text text-darken-3">
                <i class="material-icons">people</i> Informações Gerais
              </div>
              <div class="collapsible-body">

                <div class="row">

                  <div class="input-field col s12 m2">
                    <input name="orcamento" id="orcamento" type="text" :value="`#${orcamento.id}`" disabled>
                    <label for="orcamento">Orçamento</label>
                  </div>

                  <div class="input-field col s12 m2">
                    <input name="massa" id="massa" type="checkbox" v-model="os.massa">
                    <label for="massa">OS em Massa</label>
                  </div>

                  <div class="input-field col s12 m8" v-show="os.massa">
                    <br/>
                    <label class="red-text">obs: para OS's em massa talvez seja necessário fracionar o valor</label>
                  </div>

                </div>

                <div class="row" v-show="os.massa">

                  <div class="input-field col s12 m3">
                    <input name="andares" id="andares" type="text" v-validate="os.massa === true ? 'required' : ''"
                           :class="{invalid: errors.has('andares')}" v-model="os.andares">
                    <label for="andares">Andares (ex: 10,1 ou 10,0)</label>
                    <small class="red-text">{{ errors.first('andares') }}</small>
                  </div>

                  <div class="input-field col s12 m3">
                    <input name="finais" id="finais" type="text" v-validate="os.massa === true ? 'required' : ''"
                           :class="{invalid: errors.has('finais')}" v-model="os.finais">
                    <label for="finais">Finais (ex: 1,2,3 ..., 10)</label>
                    <small class="red-text">{{ errors.first('finais') }}</small>
                  </div>

                  <div class="col s12 m3">
                    <label for="estrutura_numeros">Padrão de Números</label>
                    <select name="estrutura_numeros" id="estrutura_numeros" v-model="os.estrutura_numeros">
                      <option value="decimal">Decimal (ex: 13)</option>
                      <option value="centena">Centena (ex 138)</option>
                      <option value="milhar">Milhar (ex: 1308)</option>
                    </select>
                    <small class="red-text">{{ errors.first('estrutura_numeros') }}</small>
                  </div>

                  <div class="input-field col s12 m3">
                    <input name="bloco" id="bloco" type="text" v-model="os.bloco">
                    <label for="bloco">Bloco (ex: Bloco A)</label>
                  </div>

                </div>

                <div class="row">

                  <div class="col s12 m4">
                    <label for="responsavel_id">*Responsável Técnico</label>
                    <select name="responsavel_id" id="responsavel_id"v-model="os.responsavel_id">
                      <option v-for="responsavel in usuarios" :value="responsavel.id">{{ responsavel.nome_completo }}
                      </option>
                    </select>
                    <small class="red-text">{{ errors.first('responsavel_id') }}</small>
                  </div>

                  <div class="col s12 m4">
                    <label for="revisao_id">Revisão</label>
                    <select name="revisao_id" id="revisao_id" v-model="os.revisao_id">
                      <option v-for="revisao in revisoes" :value="revisao.id">{{ revisao.tipo }}</option>
                    </select>
                  </div>

                  <div class="input-field col s12 m4" v-show="!os.massa">
                    <input name="apartamento" id="apartamento" type="text" v-model="os.apartamento">
                    <label for="apartamento">Apartamento (não preencher para OS's em massa)</label>
                  </div>

                </div>

                <div class="row" v-show="!os.massa">

                  <div class="input-field col s12 m3">
                    <input name="medidor" id="medidor" type="text" v-model="os.medidor">
                    <label for="medidor">Medidor de Gás</label>
                  </div>

                  <div class="input-field col s12 m3">
                    <input name="medidor_marca" id="medidor_marca" type="text" v-model="os.medidor_marca">
                    <label for="medidor_marca">Marca do Medidor</label>
                  </div>

                  <div class="input-field col s12 m3">
                    <input name="medidor_numero" id="medidor_numero" type="text" v-model="os.medidor_numero">
                    <label for="medidor_numero">Número do Medidor</label>
                  </div>

                  <div class="input-field col s12 m3">
                    <input name="medidor_leitura" id="medidor_leitura" type="text" v-model="os.medidor_leitura">
                    <label for="medidor_leitura">Leitura do Medidor</label>
                  </div>

                </div>

                <div class="row">

                  <div class="input-field col s12 m4">
                    <input name="valor" id="valor" type="number" step="any" min="0" v-model="os.valor">
                    <label for="valor">*R$ da Obra</label>
                  </div>

                  <div class="input-field col s12 m4">
                    <i class="material-icons prefix">event</i>
                    <input name="inicio" id="icon_inicio" type="date" v-model="os.inicio"
                           :data-value="os.inicio">
                    <label for="icon_inicio" class="active">Data de Início</label>
                    <small class="red-text">{{ errors.first('inicio') }}</small>
                  </div>

                  <div class="input-field col s12 m4">
                    <input name="tempo_execucao" id="tempo_execucao" type="number" v-model="os.tempo_execucao">
                    <label for="tempo_execucao">Tempo de Execução (dias)</label>
                  </div>

                </div>

              </div>

            </li>

            <li>
              <div class="collapsible-header green-text text-darken-3">
                <i class="material-icons">assignment</i> Descrição dos Serviços
              </div>
              <div class="collapsible-body">

                <div class="row">
                  <div class="col s12">
                    <!-- quill-editor -->
                    <label>Descrição</label>
                    <quill-editor ref="os.descricao"
                                  v-model="os.descricao"
                                  :options="editorDescricao">
                    </quill-editor>
                    <small class="red-text">{{ errors.first('descricao') }}</small>
                  </div>
                </div>

                <div class="row">
                  <div class="col s12">
                    <!-- quill-editor -->
                    <label>Dificuldades Encontradas</label>
                    <quill-editor ref="os.dificuldades"
                                  v-model="os.dificuldades"
                                  :options="editorDificuldades">
                    </quill-editor>
                    <small class="red-text">{{ errors.first('dificuldades') }}</small>
                  </div>
                </div>

                <div class="row">
                  <div class="col s12">
                    <!-- quill-editor -->
                    <label>Solução Proposta</label>
                    <quill-editor ref="os.solucao"
                                  v-model="os.solucao"
                                  :options="editorSolucao">
                    </quill-editor>
                    <small class="red-text">{{ errors.first('solucao') }}</small>
                  </div>
                </div>

              </div>

            </li>

          </ul>

          <br clear="all"/>
          <hr/>
          <br clear="all"/>

          <div class="row">

            <div class="col s12">
              <button type="button" @click.prevent="validate" class="waves-effect waves-light btn" :disabled="loading">
                Gerar OS
              </button>
            </div>

          </div>

        </div>

      </div>

    </form>

  </div>
</template>



// WEBPACK FOOTER //
// src/features/os/os/formNovo.vue